var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02109 4.83146C1.40077 4.83146 0.896094 4.32679 0.896094 3.70646C0.896094 3.08614 1.40077 2.58146 2.02109 2.58146C2.64142 2.58146 3.14609 3.08614 3.14609 3.70646C3.14609 3.95498 3.34755 4.15646 3.59609 4.15646C3.84463 4.15646 4.04609 3.95498 4.04609 3.70646C4.04609 2.74456 3.37171 1.93774 2.47109 1.73248V1.23146C2.47109 0.982951 2.26963 0.781464 2.02109 0.781464C1.77255 0.781464 1.57109 0.982951 1.57109 1.23146V1.73248C0.670475 1.93774 -0.00390625 2.74456 -0.00390625 3.70646C-0.00390625 4.82305 0.904503 5.73146 2.02109 5.73146C2.64142 5.73146 3.14609 6.23614 3.14609 6.85646C3.14609 7.47679 2.64142 7.98146 2.02109 7.98146C1.40077 7.98146 0.896094 7.47679 0.896094 6.85646C0.896094 6.60795 0.694634 6.40646 0.446094 6.40646C0.197553 6.40646 -0.00390625 6.60795 -0.00390625 6.85646C-0.00390625 7.81837 0.670475 8.62519 1.57109 8.83045V9.33146C1.57109 9.57998 1.77255 9.78146 2.02109 9.78146C2.26963 9.78146 2.47109 9.57998 2.47109 9.33146V8.83045C3.37171 8.62519 4.04609 7.81837 4.04609 6.85646C4.04609 5.73987 3.13768 4.83146 2.02109 4.83146Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.775b698f6273d0e24315e88c4ad5a213.svg";
export { ForwardRef as ReactComponent };